export default __webpack_public_path__ + "static/media/bnb-logo.d8c61230.svg";